import React from "react";
import { formatDateRange } from "../utils/date";

const MODES = [
  { value: "previous", label: "Prethodni period" },
  { value: "year", label: "Prošla godina" },
];

const segClass = (active) =>
  `h-8 shrink-0 whitespace-nowrap rounded px-3 text-sm font-medium transition-colors ${
    active
      ? "bg-surface text-slate-900 shadow-card dark:bg-slate-700 dark:text-white"
      : "text-slate-600 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-100"
  }`;

/** Chooses what the KPI changes are compared with, and shows the exact compared dates. */
export default function CompareToggle({ mode, onChange, startDate, endDate }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs font-medium text-slate-500 dark:text-slate-400">Poređenje</span>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <div
          role="group"
          aria-label="Poređenje"
          className="inline-flex overflow-x-auto rounded-md border border-slate-300 bg-slate-100 p-0.5 dark:border-slate-700 dark:bg-slate-900"
        >
          {MODES.map((m) => (
            <button key={m.value} type="button" aria-pressed={mode === m.value} onClick={() => onChange(m.value)} className={segClass(mode === m.value)}>
              {m.label}
            </button>
          ))}
        </div>
        <span className="text-xs tabular-nums text-slate-500 dark:text-slate-400">{formatDateRange(startDate, endDate)}</span>
      </div>
    </div>
  );
}
